/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AddTenantNamespaceButtonLayout from "../layout/AddTenantNamespaceButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import getSchema from "../../lib/api/getSchema";

function AddTenantNamespaceButton ( props ) {

    const { t } = useTranslation();

    const { id, tenant, refresh, onSuccess, onFailure, ...others } = props;

    const [ open, setOpen ] = useState(false);
    const [ schema, setSchema ] = useState ();

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }
        
        refresh.refresh ();

    };

    useEffect ( async () => {

        let mounted = true;

        let schema = await getSchema ( "TenantTranslation" );

        if ( mounted && schema ) {

            let column = {};

            column.name = "tenantName";
            column.formGroup = 0;
            column.formOrder = 1;
            column.type = "text";
            column.readonly = true;     
            column.disabled = true;
            
            schema.columns.push ( column );

            setSchema ( schema );

        }

        return ( () => {
            mounted = false;
        } );

    }, [] );

    const setInitialDataCallback = ( formData ) => {
            
        if ( !formData ) {

            formData = {};
            
        }

        formData.tenantId = tenant.tenantId;
        formData.tenantName = tenant.tenantName;

    }

    return (

        <>
            <AddTenantNamespaceButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id+"append-dialog"}
                mode="create"
                formId={id+"append-form"}
                title={ t ( "dialog.title.TenantTranslation.create" ) }
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                setInitialDataCallback={setInitialDataCallback}
            />
        </>

    );
    
}

export default AddTenantNamespaceButton;

